import { Box, Flex } from 'rebass'

import React from 'react'
import { css } from 'glamor'

const Component = ({ component, children, mergeCss, ...otherProps }) => {
  return React.createElement(
    component,
    {
      ...css(
        {
          paddingTop: 1,
          paddingBottom: 1,
          minHeight: '66vh',
          '@media (max-width: 991.98px)': {
            paddingLeft: 16,
            paddingRight: 16,
          },
          '@media (min-width: 992px)': {
            paddingLeft: '15vw',
            paddingRight: '15vw',
          },
        },
        mergeCss || {}
      ),
      ...otherProps,
    },
    children
  )
}

export const BoxSection = props => {
  return <Component component={Box} {...props} />
}

export const FlexSection = props => {
  return <Component component={Flex} {...props} />
}

export default BoxSection
